import Swiper, { Navigation, Pagination, Autoplay, Controller, Grid } from 'swiper';

export default (() => {
  const relatedSlider = $('.related-wrapper')
  // Related Slider
  relatedSlider.each(function () {
    const slider = $(this).find('.slider');
    const buttonNext = $(this).find('.swiper-button-next')[0];
    const buttonPrev = $(this).find('.swiper-button-prev')[0];

    const swiper = new Swiper(slider.get(0), {
      modules: [Autoplay, Navigation, Controller, Pagination, Grid],
      spaceBetween: 15,
      slidesPerView: 1.15,
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
}) ();



// WEBPACK FOOTER //
// ./scripts/layout/slider.js